<template>
	<div class="page">
		<el-form >
			<el-row>
				<el-col :span="7" :offset="7">
					<el-form-item label="账号：" :label-width="formLabelWidth">
						{{userInfo.uName}}
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="7" :offset="7">
					<el-form-item label="原密码：" :label-width="formLabelWidth" >
						<el-input type="password" v-model="oldPwd" placeholder="请输入原密码"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="7" :offset="7">
					<el-form-item label="新密码：" :label-width="formLabelWidth" >
						<el-input type="password" v-model="newPwd" placeholder="请输入新密码"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="7" :offset="7">
					<el-form-item label="确认新密码：" :label-width="formLabelWidth" >
						<el-input type="password" v-model="newPwd1" placeholder="请再次输入新密码"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="7" :offset="7">
					<el-form-item label="" :label-width="formLabelWidth" >
						<el-button type="primary" style="width:100%;margin-top:50px;" @click="submit">提交</el-button>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				formLabelWidth: '130px',
				oldPwd:'',
				newPwd:'',
				newPwd1:'',
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.userInfo;
			}
		},
		mounted() {

		},
		methods: {
			submit(){
				if(this.oldPwd.length==0){
					this.$message({
						message: '请输入原密码',
						type: 'error'
					});
					return ;
				}
				if(this.newPwd.length==0){
					this.$message({
						message: '请输入新密码',
						type: 'error'
					});
					return ;
				}
				if(this.newPwd!==this.newPwd1){
					this.$message({
						message: '两次新密码输入不一致',
						type: 'error'
					});
					return ;
				}
				let params = {
					oldPwd:this.oldPwd,
					newPwd:this.newPwd,
				}
				this.$http.post(process.env.VUE_APP_Url_8000 +'/api/ManagerInfo/updatePwd', params).then(res => {
					if (res.code == 0) {
						this.$message({
							message: '密码修改成功',
							type: 'success'
						});
						this.$router.back();
					}
				})
			}
		}
	}
</script>
<style lang="scss" scoped>
	.page {
		padding:100px 0 0;height: 100%;box-sizing: border-box;background-color: #fff;
	}
</style>
